import { gql } from "@apollo/client";
import { MilestoneInfo } from "./getMilestonesCall";

export const MARK_MILESTONE_AS_DELETED = gql`
  mutation MarkAsDeleted($domain: String!, $ids: [Int!]!) {
    milestone {
      markAsDeleted(domain: $domain, ids: $ids) {
        message
        success
        code
        updatedValues {
          milestoneName: name
          milestoneId: milestone_id
          deleted
        }
      }
    }
  }
`

interface MarkMilestonesAsDeleted {
  message: string;
  success: boolean;
  code: string;
  updatedValues?: MilestoneInfo[]
}

export interface MarkMilestonesAsDeletedResponse {
  milestone: {
    markAsDeleted: MarkMilestonesAsDeleted
  }
}